import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TwoFactorAuthService } from '../../../services/two-factor/two-factor-auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-verify-2fa-modal',
  templateUrl: './verify-2fa-modal.component.html',
  styleUrls: ['./verify-2fa-modal.component.css']
})
export class Verify2FAModalComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() isVisible: boolean = false;
  @Output() verified = new EventEmitter<boolean>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() codeReceived = new EventEmitter<string>();

  verifyForm: FormGroup;
  isLoading: boolean = false;
  attemptsLeft: number = 3;

  constructor(
    private fb: FormBuilder,
    private twoFactorService: TwoFactorAuthService
  ) {
    this.verifyForm = this.fb.group({
      code: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]]
    });
  }

  ngOnInit() {
    // Auto-focus en el input cuando se abre el modal
    if (this.isVisible) {
      setTimeout(() => {
        const input = document.getElementById('code') as HTMLInputElement;
        if (input) input.focus();
      }, 100);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isVisible']) {
      if (this.isVisible) {
        this.showModal();
      } else {
        this.hideModal();
      }
    }
  }

  ngAfterViewInit() {
    if (this.isVisible) {
      this.showModal();
    }
  }

  private showModal() {
    setTimeout(() => {
      const modalElement = document.getElementById('verify2FAModal');
      if (modalElement) {
        // Usar Bootstrap 5 para mostrar el modal
        const modal = new (window as any).bootstrap.Modal(modalElement, {
          backdrop: 'static',
          keyboard: false
        });
        modal.show();
        
        // Auto-focus en el input
        setTimeout(() => {
          const input = document.getElementById('code') as HTMLInputElement;
          if (input) input.focus();
        }, 100);
      }
    }, 50);
  }

  private hideModal() {
    const modalElement = document.getElementById('verify2FAModal');
    if (modalElement) {
      const modalInstance = (window as any).bootstrap?.Modal?.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
  }

  onCodeInput(event: any) {
    const value = event.target.value.replace(/\D/g, ''); // Solo números
    this.verifyForm.patchValue({ code: value });
  }

  async onSubmit() {
    if (this.verifyForm.invalid) return;

    this.isLoading = true;
    
    try {
      const code = this.verifyForm.value.code;
      const isValid = await this.twoFactorService.verifyTokenAPI(code);
      
      if (isValid) {
        this.codeReceived.emit(code);
        await Promise.resolve();
        this.verified.emit(true);
        this.closeModal();
      } else {
        this.attemptsLeft--;
        
        if (this.attemptsLeft <= 0) {
          this.cancelled.emit();
          this.closeModal();
          Swal.fire({ title: 'Error', text: 'Demasiados intentos fallidos. Operación cancelada.', icon: 'error', confirmButtonColor: '#ff8c00' });
        } else {
          Swal.fire({ title: 'Error', text: `Código incorrecto. Te quedan ${this.attemptsLeft} intentos.`, icon: 'error', confirmButtonColor: '#ff8c00' });
          this.verifyForm.patchValue({ code: '' });
        }
      }
    } catch (error: any) {
      Swal.fire({
        title: 'Error',
        text: 'Ha ocurrido un error durante la verificación',
        icon: 'error',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#ff8c00'
      });
    } finally {
      this.isLoading = false;
    }
  }

  closeModal() {
    this.verifyForm.reset();
    this.attemptsLeft = 3;
    this.isVisible = false;
    this.hideModal();
  }

  onCancel() {
    this.cancelled.emit();
    this.closeModal();
  }
}
